import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    projectId: "monospace-v3",
    appId: "1:20943784233:web:9da34ba38c95f7d5f64f38",
    storageBucket: "monospace-v3.firebasestorage.app",
    apiKey: "AIzaSyBUcVqojkOdc7IPfHD8ogiO1mfW1WW2S4o",
    authDomain: "monospace-v3.firebaseapp.com",
    messagingSenderId: "20943784233",
    measurementId: "G-6WMY14YLES"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
